import { Component, OnInit, Input } from '@angular/core';
import {DickerSelectListItem, PaymentViewModel} from '../../../../models/check-out.model';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../../services/checkout.service';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../../../services/common.service';
import { Observable } from 'rxjs'
@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.css']
})
export class PaymentSummaryComponent implements OnInit {

  @Input() paymentSummary: PaymentViewModel;
  @Input() enableEdit: boolean;
  selectedDigitalWallet$: Observable<DickerSelectListItem>;
  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService
    , private ngProgress: NgProgress
    , private commonService: CommonService) { }

  ngOnInit() {
    this.selectedDigitalWallet$ = this.checkOutService.selectedDigitalWallet$.asObservable();
  }

  editPayment() {
    this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
  }
}
